export default __webpack_public_path__ + "static/media/portfolio-101.f3cbb4bc.jpg";